import Papa from 'papaparse';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { AccountStatement } from './accountStatement';
import { accountSlug } from './accountStatementExportPdf';
import type { StatementViewRow } from './useAccountStatement';

const fmtBrl = (n: number) => n.toFixed(2).replace('.', ',');

interface Input {
  accountName: string;
  fromDate: Date;
  toDate: Date;
  statement: AccountStatement;
  rows: StatementViewRow[];
}

const TYPE_LABEL = { income: 'Receita', expense: 'Despesa', transfer: 'Transferência' } as const;

export function exportAccountStatementCsv({
  accountName,
  fromDate,
  toDate,
  statement,
  rows,
}: Input): void {
  const emptyMovement = { Tipo: '', Categoria: '', Contraparte: '', Entrada: '', Saída: '' };

  const csvRows = [
    { Data: '', Descrição: 'Saldo anterior', ...emptyMovement, Saldo: fmtBrl(statement.openingBalance) },
    ...rows.map((r) => ({
      Data: format(r.entry.refDate, 'dd/MM/yyyy', { locale: ptBR }),
      Descrição: r.counterpartAccountName
        ? `${r.entry.tx.description} (${r.entry.direction === 'out' ? '→' : '←'} ${r.counterpartAccountName})`
        : r.entry.tx.description,
      Tipo: TYPE_LABEL[r.entry.tx.type],
      Categoria: r.categoryName,
      Contraparte: r.counterpartyName ?? '',
      Entrada: r.entry.direction === 'in' ? fmtBrl(r.entry.amount) : '',
      Saída: r.entry.direction === 'out' ? fmtBrl(r.entry.amount) : '',
      Saldo: fmtBrl(r.entry.runningBalance),
    })),
    { Data: '', Descrição: 'Saldo final', ...emptyMovement, Saldo: fmtBrl(statement.closingBalance) },
  ];

  const csv = Papa.unparse(csvRows, { delimiter: ';' });
  const bom = '﻿';
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `extrato-${accountSlug(accountName)}-${format(fromDate, 'yyyy-MM-dd')}-a-${format(
    toDate,
    'yyyy-MM-dd',
  )}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
